import React from 'react';
import { Search } from 'lucide-react';
import { cn } from '../index';
import { Input, type InputProps } from './Input';

export interface SearchInputProps extends Omit<InputProps, 'type'> {
  containerClassName?: string;
  onClear?: () => void;
}

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, containerClassName, onClear: _onClear, value, ...props }, ref) => {
    return (
      <div className={cn('relative w-full', containerClassName)}>
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-[var(--fg-muted)] pointer-events-none" />
        <Input
          ref={ref}
          type="search"
          value={value}
          className={cn('pl-9', className)}
          {...props}
        />
      </div>
    );
  },
);
SearchInput.displayName = 'SearchInput';
